import dayjs from 'dayjs/esm';
import duration from 'dayjs/esm/plugin/duration';
import isSameOrAfter from 'dayjs/esm/plugin/isSameOrAfter';
export type { Duration } from 'dayjs/esm/plugin/duration';

dayjs.extend(isSameOrAfter);
dayjs.extend(duration);

export default dayjs;
